<template>
  <LiquidacionReportesPageLayout :title="messages.DETALLADO_PAGE_TITLE">
    <LiquidacionDetalladoTab />
  </LiquidacionReportesPageLayout>
</template>

<script>
import LiquidacionReportesPageLayout from "@/components/LiquidacionReportes/LiquidacionReportesPageLayout.vue";
import LiquidacionDetalladoTab from "@/components/LiquidacionReportes/LiquidacionDetalladoTab.vue";
import { MESSAGES } from "@/services/liquidacion-reportes/liquidacion-reportes.constants";

import "@/styles/liquidacion-reportes/liquidacion-reportes.css";

export default {
  name: "ReportesLiquidacionesDetallado",

  components: {
    LiquidacionReportesPageLayout,
    LiquidacionDetalladoTab,
  },

  data() {
    return {
      messages: MESSAGES,
    };
  },
};
</script>
